// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"69d49615","133":"8d4f9eae","182":"4f3bea39"}[chunkId] + ".chunk.js";
};